<template>
    <ui-date-picker-range
        @input="onInput"
        :labels="[$t('dashboard.period_filter')]"
        :range="queryFormatted"
        class="d-flex justify-content-lg-end"
    ></ui-date-picker-range>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapMutations, mapState } from 'vuex';

import UiDatePickerRange from '../ui/date-picker-range.vue';

export default {
    name: 'DashboardFilters',
    components: {
        UiDatePickerRange,
    },
    data() {
        return {
            query: {},
            queryFormatted: {},
        };
    },
    created() {
        if (window.location.search) {
            this.getLocationSearch();
        }
    },
    mounted() {
        this.updateQuery();
        this.cloneQuery();
    },
    computed: {
        ...mapState('dashboard', {
            originalQuery: 'query',
        }),
    },
    methods: {
        ...mapActions('dashboard', [
            'getLocationSearch',
        ]),

        ...mapMutations('dashboard', [
            'updateQuery',
        ]),

        cloneQuery() {
            this.query = JSON.parse(JSON.stringify(this.originalQuery));
            this.queryFormatted = {
                start: this.query.start_date,
                end: this.query.end_date,
            };
        },

        onInput(query) {
            const formattedQuery = {
                start_date: dayjs(query.start).format('YYYY-MM-DD'),
                end_date: dayjs(query.end).format('YYYY-MM-DD'),
            };

            this.updateQuery(formattedQuery);
        },
    },
};
</script>
